<template>
  <div class="cookie-consent-bar elevation-12" v-if="visible">
    <v-toolbar dense :color="color">
      <v-toolbar-title v-html="message" />
      <v-spacer />
      <v-btn raised v-html="view" @click="viewPolicy" />
      <v-btn raised v-html="dismiss" @click="dismissMessage" />
    </v-toolbar>
  </div>
</template>
<script>
  import Mixins from '../helpers/Mixins'

  export default {
    name: 'CookieConsentBar',
    mixins: [
      Mixins
    ],
    data () {
      return {
        message: this.$attrs.message || 'We use cookies to ensure you get the best experience.',
        dismiss: this.$attrs.ok || 'OK',
        view: this.$attrs.view || 'Policy',
        visible: false,
        page: this.$attrs.page || '/cookies',
        cookie: this.$attrs.cookie || '_cookie_policy_',
        days: this.$attrs.days || 7,
        color: this.$store.state.baseColor
      }
    },
    mounted () {
      if (!this.getCookie(this.cookie)) {
        this.visible = true
      }
    },
    methods: {
      /**
       * Navigate to the cookie policy page
       * @method viewPolicy
       * @return void
       */
      viewPolicy () {
        this.$router.push({
          name: 'PagePage',
          params: {
            slug: this.page
          }
        })
      },
      /**
       * Close the message
       * @method dismissMessage
       * @return void
       */
      dismissMessage () {
        this.visible = false
        this.setCookie(this.cookie, true, this.days)
      }
    }
  }
</script>
<style>
.cookie-consent-bar
{
  position: fixed;
  z-index: 1000;
  bottom: 0;
  width: 100%;
  opacity: .85;
  transition: opacity .25s ease-in-out;
}

.cookie-consent-bar:hover
{
  opacity: 1;
}

.cookie-consent-bar .toolbar__title
{
  font-size: 1em;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/CookieConsentBar.vue